"use client";

export { ErrorMessage as default } from "@/ui/error-message/error-message";
